// store/student/exam/store/_actions.js
import * as types from './_actionTypes';

// Get available exams
export const getAvailableExams = () => ({
  type: types.GET_AVAILABLE_EXAMS_REQUEST
});

export const getAvailableExamsSuccess = (data) => ({
  type: types.GET_AVAILABLE_EXAMS_SUCCESS,
  payload: data
});

export const getAvailableExamsFailure = (error) => ({
  type: types.GET_AVAILABLE_EXAMS_FAILURE,
  payload: error
});

// Start exam
export const startExam = (examId) => ({
  type: types.START_EXAM_REQUEST,
  payload: { examId }
});

export const startExamSuccess = (data) => ({
  type: types.START_EXAM_SUCCESS,
  payload: data
});

export const startExamFailure = (error) => ({
  type: types.START_EXAM_FAILURE,
  payload: error
});

// Save answer
export const saveAnswer = (attemptId, questionId, selectedAnswer) => ({
  type: types.SAVE_ANSWER_REQUEST,
  payload: { attemptId, questionId, selectedAnswer }
});

export const saveAnswerSuccess = (data) => ({
  type: types.SAVE_ANSWER_SUCCESS,
  payload: data
});

export const saveAnswerFailure = (error) => ({
  type: types.SAVE_ANSWER_FAILURE,
  payload: error
});

// Submit exam
export const submitExam = (attemptId) => ({
  type: types.SUBMIT_EXAM_REQUEST,
  payload: { attemptId }
});

export const submitExamSuccess = (data) => ({
  type: types.SUBMIT_EXAM_SUCCESS,
  payload: data
});

export const submitExamFailure = (error) => ({
  type: types.SUBMIT_EXAM_FAILURE,
  payload: error
});

// Get exam results
export const getExamResults = (attemptId) => ({
  type: types.GET_EXAM_RESULTS_REQUEST,
  payload: { attemptId }
});

export const getExamResultsSuccess = (data) => ({
  type: types.GET_EXAM_RESULTS_SUCCESS,
  payload: data
});

export const getExamResultsFailure = (error) => ({
  type: types.GET_EXAM_RESULTS_FAILURE,
  payload: error
});

// Get exam history
export const getExamHistory = () => ({
  type: types.GET_EXAM_HISTORY_REQUEST
});

export const getExamHistorySuccess = (data) => ({
  type: types.GET_EXAM_HISTORY_SUCCESS,
  payload: data
});

export const getExamHistoryFailure = (error) => ({
  type: types.GET_EXAM_HISTORY_FAILURE,
  payload: error
});

// Local state management
export const updateCurrentAnswer = (questionId, answer) => ({
  type: types.UPDATE_CURRENT_ANSWER,
  payload: { questionId, answer }
});

export const setExamTimer = (timeRemaining) => ({
  type: types.SET_EXAM_TIMER,
  payload: timeRemaining
});

export const resetExamState = () => ({
  type: types.RESET_EXAM_STATE
});

export const setAutoSaveStatus = (status) => ({
  type: types.SET_AUTO_SAVE_STATUS,
  payload: status
});